import React, { useEffect, useState } from "react"
import { Button, Form, Select } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { getQuestionnaireTemplates } from "store/question"
import { CreateQuestionTemplateModal } from "./CreateQuestionTemplateModal/CreateQuestionTemplateModal"
import styles from "./Questions.module.css"

export const Questions = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const templates = useSelector((state) => state.question.questionnaireTemplates.data)
  const isLoading = useSelector((state) => state.question.questionnaireTemplates.loading)
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    dispatch(getQuestionnaireTemplates(undefined, undefined, undefined, { paginate: false }))
  }, [dispatch])

  const templateOptions = (templates || []).map((tmpl) => ({ value: tmpl.id, label: tmpl.name }))

  return (
    <>
      <Card
        title={t("experiences.wizard.additional_info.questions.title")}
        className="mb-xl"
        extra={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)} className={styles.addNewBtn}>
            {t("experiences.wizard.additional_info.questions.add_btn")}
          </Button>
        }
      >
        <Form.Item
          name="question_template"
          label={t("experiences.wizard.additional_info.questions.label")}
          colon={false}
          className="mb-0"
        >
          <Select
            showSearch
            allowClear
            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
            options={templateOptions}
            loading={isLoading}
            placeholder={t("experiences.wizard.additional_info.questions.placeholder")}
            size="large"
            className={styles.questionsSelect}
          />
        </Form.Item>
      </Card>

      {isModalOpen && (
        <CreateQuestionTemplateModal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
        />
      )}
    </>
  )
}
